import { Component, HostListener, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { LocalService, StoreService, UserService, AuthService, HeaderPopoverService } from "../../services";
import { CONSTANTS } from "../../../config";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material";
import { Subscription } from "rxjs";
import { AcknowledgementService } from "../../services/acknowledgement.service";
import { CommonRouteService } from "../../services/common-route.service";
import { filterUserRoles } from "src/app/shared/utils/user.util";

@Component({
  selector: "app-user-profile-dropdown",
  templateUrl: "./user-profile-dropdown.component.html",
  styleUrls: ["./user-profile-dropdown.component.scss"],
})
export class UserProfileDropdownComponent implements OnInit, OnDestroy {
  userData: any;
  switchRole: string = "";
  profileFlag: boolean = false;
  isCiscoAdminText: boolean = false;
  managerFlag: boolean = false;
  sellerFlag: boolean = false;
  ciscoAdminNavText: boolean = false;
  approverFlag: boolean = false;
  approverRoleStatus: boolean = false;
  onlyApprover: boolean = false;
  partnerLeaderFlag: boolean = false;
  dropDownFlag: boolean = false;
  profileImage: string = "";

  private userActivatedSubscription: Subscription | null = null;
  private subscription: Subscription | null = null;
  private profileImageSubscription: Subscription | null = null;
  private updateRoleSubscription: Subscription | null = null;
  private logoutSubscription: Subscription | null = null;
  private popoverSub: Subscription | null = null;

  constructor(
    private storeService: StoreService,
    private userService: UserService,
    public translate: TranslateService,
    public dialog: MatDialog,
    private acknowledgementService: AcknowledgementService,
    private commonRouteService: CommonRouteService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private headerPopoverService: HeaderPopoverService
  ) {
    translate.setDefaultLang("English");
  }

  @HostListener("document:click", ["$event"]) clickedOutside($event: any) {
    this.dropDownFlag = false;
  }

  ngOnInit() {
    this.getUserData();
    this.profileImageSubscription = this.storeService.currentProfileImage.subscribe((image: string) => {
      this.profileImage = image;
    });
    this.popoverSub = this.headerPopoverService.activePopover$.subscribe((name: string) => {
      if (name !== 'profile') {
        this.dropDownFlag = false;
      }
    });

    const savedRole = localStorage.getItem('selectedRole');
    if (savedRole) {
      this.switchRole = savedRole;
      if (savedRole === 'manager') {
        this.partnerLeaderFlag = true;
      } else if (savedRole === 'approver') {
        this.approverRoleStatus = true;
      }
    }

    this.userActivatedSubscription = this.storeService.userActivated.subscribe(
      (role: any) => {
        setTimeout(() => {
          if (role !== "") {
            this.switchRole = role;
            if (this.approverRoleStatus) {
              this.switchRole = "approver";
            }
          }

          if (
            this.userData &&
            this.userData.hasOwnProperty("userType") &&
            this.userData.userType === "PAM"
          ) {
            if (this.switchRole === "seller") {
              this.switchRole = "manager";
            }
            if (this.switchRole === "manager") {
              this.partnerLeaderFlag = true;
            }
            if (this.approverRoleStatus) {
              this.switchRole = "approver";
            }
          }

          if (this.switchRole === "home") {
            this.userData = LocalService.get("userProfile");
          }

          this.getRoles();
          this.cdr.markForCheck();
        }, 0);
      }
    );

    this.getRoles();
    this.updateRoleSubscription = this.storeService.updateRole.subscribe((roleUpdated) => {
      if (roleUpdated) this.getRoles();
    });

    const isLoggedIn = this.authService.isAuthenticated;
    if (isLoggedIn) {
      if (
        this.userData &&
        this.userData.roles &&
        this.userData.roles.find((item: any) => item.name === "CISCO_ADMIN")
      ) {
        this.ciscoAdminNavText = true;
      }
      if (this.userData && this.userData.createSalesChg) {
        this.isCiscoAdminText = true;
      }
      const approverRole = LocalService.get("approverRole");
      if (
        approverRole &&
        approverRole.approverRole &&
        this.userData &&
        this.userData.roles &&
        this.userData.roles.find((item: any) => item.name === "CISCO_ADMIN") &&
        !(this.userData.hasOwnProperty("userType") && this.userData.userType === "PAM") &&
        !this.managerFlag &&
        !this.sellerFlag
      ) {
        this.userNavigation("createsaleschg");
      }
    }
  }

  getUserData() {
    this.subscription = this.storeService.getUserObj().subscribe((res: any) => {
      if (res !== null) {
        this.userData = res;
        if (
          res.active === true &&
          res.hasOwnProperty("userType") &&
          res.userType === "PAM"
        ) {
          if (res.pamActivity && res.pamActivity.createProfleClicked) {
            this.profileFlag = true;
          }
          this.managerFlag = true;
        }
      }
    });
  }

  getRoles() {
    this.userData = LocalService.get("userProfile");
    if (
      this.userData &&
      this.userData.active &&
      this.userData.company &&
      this.userData.company.profileComplete
    ) {
      if (
        this.userData.hasOwnProperty("userType") &&
        this.userData.userType === "PAM"
      ) {
        this.managerFlag = true;
        if (this.userData.pamActivity && this.userData.pamActivity.createProfleClicked) {
          this.profileFlag = true;
        }
      } else {
        this.managerFlag = filterUserRoles(this.userData, CONSTANTS.manager).length > 0;
        this.sellerFlag = filterUserRoles(this.userData, CONSTANTS.seller).length > 0;
      }
    }
    const approverRole = LocalService.get("approverRole");
    const onlyApprover = LocalService.get("onlyApprover");
    if (onlyApprover) {
      this.onlyApprover = true;
      this.approverRoleStatus = false;
      this.approverFlag = false;
    } else {
      this.approverFlag = approverRole && approverRole.approverRole ? true : false;
    }
  }


  get isOnHomeRoute(): boolean {
    return this.router.url === '/home';
  }

  get isOnProfileRoute(): boolean {
    return this.router.url.startsWith('/profile');
  }

  get isOnManagerRoute(): boolean {
    return this.router.url.startsWith('/home/manager');
  }

  get isOnSellerRoute(): boolean {
    return this.router.url.startsWith('/home/seller');
  }

  get isOnApproverRoute(): boolean {
    return this.router.url.startsWith('/approver');
  }

  toggleDropdown(event: MouseEvent): void {
    event.stopPropagation();
    this.dropDownFlag = !this.dropDownFlag;
    if (this.dropDownFlag) {
      this.headerPopoverService.open('profile');
    }
  }

  onChangeRole() {
    this.storeService.bannerData.next("banner");
  }

  getRoleDisplay(): string {
    if (this.approverRoleStatus) return this.translate.instant('header.approver');
    if (this.switchRole === 'profile') return this.translate.instant('header.iconHolder3');
    if (this.switchRole === 'manager') {
      return this.isCiscoAdminText
        ? this.translate.instant('header.iconheaderCreateSalesChalg')
        : this.translate.instant('header.iconHolder4');
    }
    if (this.switchRole === 'seller') return this.translate.instant('header.iconHolder5');
    if (this.switchRole === 'home') return this.translate.instant('header.iconHolder6');
    return '';
  }

  userNavigation(val: string) {
    this.storeService.bannerData.next("banner");
    setTimeout(() => {
      if (val === "createsaleschg") {
        this.getAcknowledgements("LEADER");
        this.isCiscoAdminText = true;
        if (this.userData) {
          this.userData.createSalesChg = true;
          LocalService.set("userProfile", this.userData);
        }
        this.storeService.setCiscoAdminFlag(true, true);
        this.partnerLeaderFlag = false;
        this.approverRoleStatus = false;
      } else if (val === "manager") {
        this.getAcknowledgements("LEADER");
        this.partnerLeaderFlag = true;
        this.isCiscoAdminText = false;
        if (this.userData) {
          this.userData.createSalesChg = false;
          LocalService.set("userProfile", this.userData);
        }
        this.storeService.setCiscoAdminFlag(false, false);
        this.approverRoleStatus = false;
      } else if (val === "seller") {
        this.getAcknowledgements("SELLER");
        this.approverRoleStatus = false;
        this.partnerLeaderFlag = false;
        this.isCiscoAdminText = false;
      } else if (val === "approver") {
        this.approverRoleStatus = true;
        this.partnerLeaderFlag = false;
        this.switchRole = "approver";
        this.isCiscoAdminText = false;
      } else {
        this.isCiscoAdminText = false;
        if (this.userData) {
          this.userData.createSalesChg = false;
          LocalService.set("userProfile", this.userData);
        }
        this.storeService.setCiscoAdminFlag(false, false);
        this.partnerLeaderFlag = false;
        this.approverRoleStatus = false;
      }
      this.cdr.markForCheck();
    }, 0);
  }

  logoutUser() {
    this.storeService.unsubscribeRoute.next(true);
    this.storeService.changeProfileImage("");
    const currentURL = window.location.href;
    if (currentURL.indexOf("cisco.com") > -1) {
      window.location.href = "https://www.cisco.com/autho/logout.html";
    } else {
      this.logoutSubscription = this.userService.logout().subscribe(
        () => {
          this.completeLogout();
        },
        () => {
          this.completeLogout();
        }
      );
    }
  }

  private completeLogout() {
    LocalService.flush("token");
    LocalService.flush("userProfile");
    LocalService.flush("selectedFile");
    LocalService.flush("pamData");
    LocalService.flush("approverRole");
    LocalService.flush("onlyApprover");
    LocalService.flush("ciscoAdminRole");
    this.authService.clearAll();
    window.location.href = "/";
  }

  getAcknowledgements(role: string) {
    this.commonRouteService.getAcknowledgements(role);
  }

  ngOnDestroy() {
    if (this.userActivatedSubscription) {
      this.userActivatedSubscription.unsubscribe();
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.profileImageSubscription) {
      this.profileImageSubscription.unsubscribe();
    }
    if (this.updateRoleSubscription) {
      this.updateRoleSubscription.unsubscribe();
    }
    if (this.logoutSubscription) {
      this.logoutSubscription.unsubscribe();
    }
    if (this.popoverSub) {
      this.popoverSub.unsubscribe();
    }
  }
}
